/* eslint no-template-curly-in-string: 0 */
import gapIcon from '../../assets/images/gap-logo.png';
import { PAYMENT_NETWORKS } from "../../utils/enums";

export const gap = {
  id: PAYMENT_NETWORKS.EGIFT_BLACKHAWK_GAP,
  displayName: "GAP™",
  paywall: {
    tile: {
      displayName: "GAP™",
      tagline: ["Use online or in-store"],
      description: "Use online or in-store",
      logo: gapIcon
    },
    disabledPaymentNetwork: {
      title: 'Endpoint Not Live',
      description: 'For this trial program, ${paymentNetwork.displayName} is only listed as an example of the 250+ options DigitalPay currently offers.  Click the button below to go back and select a live network. Live networks are not “grayed out.”'
    },
  },
};

export default gap;
